module.exports = __webpack_public_path__ + "static/media/crucero.ff4f8a97.svg";